import { Command } from 'ckeditor5/src/core';
import * as uuid from 'uuid';

import { CHECKBOX_ATTR_CHECKED, CHECKBOX_ATTR_ID, CHECKBOX_OUT_COMMANDS, COMPONENT_NAME } from '../constants';

export default class CheckBoxCreateCommand extends Command {
	execute( ) {
		const checked = false;
		const editor = this.editor;
		const id = uuid.v4();
		const selection = editor.model.document.selection;

		editor.model.change( writer => {
			const checkbox = createCheckBox( selection, writer, id, checked );

			editor.model.insertContent( checkbox );
			editor.model.insertContent( writer.createText( ' ' ) );

			this.fire( CHECKBOX_OUT_COMMANDS.CREATE, { checked, id } );
		} );
	}

	refresh() {
		const model = this.editor.model;
		const selection = model.document.selection;
		const allowedIn = model.schema.findAllowedParent( selection.getFirstPosition(), COMPONENT_NAME );
		this.isEnabled = allowedIn !== null;
	}
}

function createCheckBox( selection, writer, id, checked ) {
	return writer.createElement( COMPONENT_NAME, {
		...Object.fromEntries( selection.getAttributes() ),
		[ `${ CHECKBOX_ATTR_ID }` ]: id,
		[ `${ CHECKBOX_ATTR_CHECKED }` ]: checked
	} );
}
